<template>
  <!-- <div id="float-ball" @click="showSlideBar()"> -->
    <!-- <i class="icon-float-ball"></i> -->
  <!-- </div> -->
  <div
    v-if="icon"
    ref="floatBall"
    class="float-ball"
    :class="`status_${dragIconStatus}`"
  >
    <img class="icon" :src="icon" alt="" />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FN from '@/utility/fn.js'
export default {
  data () {
    this.dragIcon = null
    this.starttime = 0 // 按下鼠标的时间，用来计算点击和松开鼠标的时间差，
    this.endtime = 0 // 松开鼠标时间
    this.timer = null // 进入隐藏状态定时器
    this.timer2 = null // 页面宽度变化防抖定时器
    this.isMb = FN.isMobile || FN.isAndroid // 是否移动端
    this.ballWidth = 50 // 浮球宽高
    this.initialX = document.documentElement.clientWidth - this.ballWidth // 默认位置
    this.initialY = document.documentElement.clientHeight * 0.6 - this.ballWidth // 默认位置
    this.offsetX = 0 // 鼠标点击位置离元素边缘的偏移量
    this.offsetY = 0 // 鼠标点击位置离元素边缘的偏移量
    return {
      icon: FN.getSession('SDK_INIT_INFO').light_logo,
      dragIconStatus: 1, // 1.右边停靠， 2. 左边停靠，3.拖动状态（拖动结束回到1状态），4.右边隐藏（1状态2秒后进入3状态） 5. 左边隐藏
    }
    // return {
    //   left_logo: FN.getSession('SDK_INIT_INFO').left_logo,
    //   right_logo: FN.getSession('SDK_INIT_INFO').right_logo,
    //   light_logo: FN.getSession('SDK_INIT_INFO').light_logo
    // }
  },
  mounted() {
    // 获取初始位置
    this.$nextTick(() => {
      this.dragIcon = this.$refs.floatBall
      this.bindEvent()
      this.initBall()
    })
  },
  beforeDestroy() {
    this.remveBindEvent()
  },
  methods: {
    ...mapMutations(['UPDATE_BALL_STATUS']),
    bindEvent() {
      this.handleDragStart = this.startDrag.bind(this)
      this.handleDragging = this.dragging.bind(this)
      this.handleDragEnd = this.endDrag.bind(this)
      this.handlePageLive = this.pageLeave.bind(this)
      this.handlePageResize = this.pageResize.bind(this)
      if (this.isMb) {
        // 移动绑定touch事件
        this.dragIcon.addEventListener('touchstart', this.handleDragStart)
        this.dragIcon.addEventListener('touchmove', this.handleDragging)
        this.dragIcon.addEventListener('touchend', this.handleDragEnd)
      } else {
        // pc绑定鼠标事件
        this.dragIcon.addEventListener('mousedown', this.handleDragStart)
        // document.body.addEventListener('mousemove', this.handleDragging)
        this.dragIcon.addEventListener('mouseup', this.handleDragEnd)
        document.body.addEventListener('mouseleave', this.handlePageLive)
        window.addEventListener('resize', this.handlePageResize)
      }
    },
    remveBindEvent() {
      // 移除绑定事件
      this.dragIcon.removeEventListener('mousedown', this.handleDragStart)
      // document.body.removeEventListener('mousemove', this.handleDragging)
      this.dragIcon.removeEventListener('mouseup', this.handleDragEnd)
      this.dragIcon.removeEventListener('touchstart', this.handleDragStart)
      this.dragIcon.removeEventListener('touchmove', this.handleDragging)
      this.dragIcon.removeEventListener('touchend', this.handleDragEnd)
      document.body.removeEventListener('mouseleave', this.handlePageLive)
      window.removeEventListener('resize', this.handlePageResize)
    },
    initBall() {
      const initialPosition = JSON.parse(localStorage.getItem('initialPosition'))
      if (initialPosition) {
        this.initialX = initialPosition[0]
        this.initialY = initialPosition[1]
      }
      if (this.initialX === 0) {
        this.dragIconStatus = 2
      }
      this.setIconStyle(this.initialX, this.initialY)
      // 隐藏图标
      this.hideIcon()
    },
    startDrag(event) {
      event.preventDefault()
      this.starttime = +new Date()
      this.clearTimer()
      if (!this.isMb) {
        this.offsetX = event.offsetX
        this.offsetY = event.offsetY
        this.dragIconStatus = 3
        document.body.addEventListener('mousemove', this.handleDragging)
        this.UPDATE_BALL_STATUS(true)
      } else if (event.targetTouches.length === 1) {
        // 移动端。且一个单点触发
        this.offsetX = this.ballWidth / 2
        this.offsetY = this.ballWidth / 2
        this.dragIconStatus = 3
      }
      
      // this.initialX = event.clientX - this.offsetX;
      // this.initialY = event.clientY - this.offsetY;
    },
    dragging(event) {
      event.preventDefault()
      if (this.dragIconStatus === 3) {
        const ev = this.isMb ? event.targetTouches[0] : event
        this.initialX = ev.clientX - this.offsetX
        this.initialY = ev.clientY - this.offsetY
        // console.log(this.initialX, this.initialY)
        this.setIconStyle(this.initialX, this.initialY)
      }
    },
    endDrag() {
      // event.preventDefault()
      this.endtime = +new Date()
      // console.log('endDragxxxxxx', event)
      const winWidth = document.documentElement.clientWidth
      const winHeight = document.documentElement.clientHeight
      if (this.dragIconStatus === 3) {
        // 触发点击事件
        this.handleClickIcon()
      }
      if (this.initialX > winWidth / 2) {
        // 在屏幕右边
        this.initialX = winWidth - this.ballWidth
        this.dragIconStatus = 1
      } else {
        // 在屏幕左边
        this.initialX = 0
        this.dragIconStatus = 2
      }
      if (this.initialY < 0) {
        this.initialY = 0
      } else if (this.initialY > winHeight - this.ballWidth) {
        this.initialY = winHeight - this.ballWidth
      }
      this.setIconStyle(this.initialX, this.initialY)
      localStorage.setItem('initialPosition', JSON.stringify([this.initialX, this.initialY]))
      if (!this.isMb) {
        this.UPDATE_BALL_STATUS(false)
        document.body.removeEventListener('mousemove', this.handleDragging)
      }
      // 隐藏图标
      this.hideIcon()
    },
    // 图标进入隐藏状态
    hideIcon() {
      // 2s后变成隐藏状态
      this.clearTimer()
      this.timer = setTimeout(() => {
        if (this.dragIconStatus === 1) {
          this.dragIconStatus = 4
        } else if (this.dragIconStatus === 2) {
          this.dragIconStatus = 5
        }
      }, 2000)
    },
    // pc鼠标离开页面时执行
    pageLeave() {
      if (this.dragIconStatus === 3) {
        this.endDrag()
      }
    },
    // pc页面宽度变化时执行
    pageResize() {
      this.clearTimer2()
      this.timer2 = setTimeout(() => {
        this.endDrag()
      }, 200);
    },
    setIconStyle(x, y) {
      // console.log('setIconStyle', x, y)
      this.dragIcon.style.left = x + 'px'
      this.dragIcon.style.top = y + 'px'
    },
    // 清楚定时器
    clearTimer() {
      clearTimeout(this.timer)
      this.timer = null
    },
    clearTimer2() {
      clearTimeout(this.timer2)
      this.timer2 = null
    },
    // 点击图标
    handleClickIcon() {
      const sub = this.endtime - this.starttime
      if (sub > 0 && sub < 300) {
        // console.log('click event', sub)
        this.$store.dispatch('SET_SDK_COMPONENT_SLIDEBAR', 'slideBar')
      }
      
    }
  }
  // activated () {
  //   this.startDrag1(document.getElementById('float-ball'), document.getElementById('float-ball')) // 开始拖动效果
  //   document.getElementById('float-ball').style.backgroundImage = `URL(${this.light_logo})`;
  // },
  // methods: {
  //   startDrag1 (source, target) {
  //     const getCss = function (o, key) {
  //       return o.currentStyle ? o.currentStyle[key] : document.defaultView.getComputedStyle(o, false)[key]
  //     }
  //     const floatBallAutoAdjust = target => {
  //       let nowLeft = parseFloat(getCss(target, 'left'))
  //       let targetW = parseFloat(getCss(target, 'width'))

  //       target.classList = 'show'
  //       target.style.backgroundImage = `URL(${this.light_logo})`;
  //       clearTimeout(window.floatBallTimeoutId)
  //       window.floatBallTimeoutId = setTimeout(() => {
  //         target.classList.add('transtion')
  //         if (nowLeft + targetW / 2 > window.innerWidth / 2) {
  //           target.style.left = window.innerWidth - targetW + 'px'
  //           target.classList.add('reverse')
  //           target.style.backgroundImage = `URL(${this.right_logo})`;
  //         } else {
  //           target.style.left = 0
  //         }

  //         window.floatBallTimeoutId = setTimeout(() => {
  //           target.classList.add('fade')

  //           window.floatBallTimeoutId = setTimeout(() => {
  //             target.classList.add('sleep')
  //             target.style.backgroundImage = `URL(${this.left_logo})`;
  //           }, 3000)
  //         }, 2000)
  //       }, 2000)
  //     }
  //     const startDrag = (source, target) => {
  //       // source触发拖拽节点， target移动节点
  //       source.addEventListener('touchstart', e => {
  //         // FN.log('touchstart')
  //         startDrag.params.offsetX =
  //     (e.clientX || e.touches[0].clientX) - parseFloat(getCss(target, 'left'))
  //         startDrag.params.offsetY =
  //     (e.clientY || e.touches[0].clientY) - parseFloat(getCss(target, 'top'))
  //         startDrag.params.targetW = parseFloat(getCss(target, 'width'))
  //         startDrag.params.targetH = parseFloat(getCss(target, 'height'))
  //         startDrag.params.flag = true

  //         target.className = 'show'
  //         target.style.backgroundImage = `URL(${this.light_logo})`;
  //         clearTimeout(window.floatBallTimeoutId)
  //       })
  //       source.addEventListener('click', e => {
  //         startDrag.params.flag = false
  //         floatBallAutoAdjust(target)
  //       })
  //       if (!startDrag.params.hasBindDocument) {
  //         startDrag.params.hasBindDocument = true
  //         document.body.addEventListener('touchend', e => {
  //           if (!startDrag.params.hasMove) return
  //           let nowLeft = parseFloat(target.style.left)
  //           let nowTop = parseFloat(target.style.top)
  //           if (nowLeft + startDrag.params.targetW > window.innerWidth) {
  //             target.style.left = window.innerWidth - startDrag.params.targetW + 'px'
  //           } else if (nowLeft < 0) target.style.left = 0
  //           if (nowTop + startDrag.params.targetH > window.innerHeight) {
  //             target.style.top = window.innerHeight - startDrag.params.targetW + 'px'
  //           } else if (nowTop < 0) {
  //             target.style.top = 0
  //           }
  //           setTimeout(() => {
  //             // alert(111)
  //             startDrag.params.flag = false
  //             startDrag.params.hasMove = false
  //           }, 100)

  //           floatBallAutoAdjust(target)
  //         })
  //         document.body.addEventListener('touchmove', e => {
  //           if (startDrag.params.flag) {
  //             clearTimeout(window.floatBallTimeoutId)
  //             target.className = 'show'
  //             target.style.backgroundImage = `URL(${this.light_logo})`;
  //             startDrag.params.hasMove = true
  //             let nowX = e.clientX || e.touches[0].clientX
  //             let nowY = e.clientY || e.touches[0].clientY
  //             target.style.left = nowX - startDrag.params.offsetX + 'px'
  //             target.style.top = nowY - startDrag.params.offsetY + 'px'
  //           }
  //         })
  //       }
  //     }

  //     startDrag.params = {
  //       offsetX: 0, // 点击处与目标left偏差
  //       offsetY: 0,
  //       flag: false,
  //       hasMove: false,
  //       hasBindDocument: false
  //     }
  //     startDrag(source, target)
  //     document.getElementById('float-ball').addEventListener('click', () => {
  //       if (!startDrag.params.hasMove) {
  //       }
  //     })
  //   },
  //   showSlideBar () {
  //     this.$store.dispatch('SET_SDK_COMPONENT_SLIDEBAR', 'slideBar')
  //   }
  // }
}
</script>
<style lang="scss" scoped>
.float-ball {
  width: 50px;
  height: 50px;
  // background-color: lightblue;
  cursor: pointer;
  position: fixed;
  /* border-radius: 50%; */
  overflow: hidden;
  transition: all .2s ease-out;
  &.status_3 {
    transition: none;
  }
  &.status_4 {
    transform: translateX(50%);
    filter: grayscale(1);
    opacity: .7;
    &:hover, &:active {
      filter: grayscale(0);
      opacity: 1;
      transform: translateX(0);
    }
  }
  &.status_5 {
    transform: translateX(-50%);
    filter: grayscale(1);
    opacity: .7;
    &:hover, &:active {
      filter: grayscale(0);
      opacity: 1;
      transform: translateX(0);
    }
  }
  .icon {
    display: block;
    width: 100%;
  }
}
// #float-ball {
//     position: absolute;
//     width: .81rem;
//     height: .81rem;
//     top: 3rem;
//     right: 0;
//     z-index: 1;
//     background-image: url(../assets/img/icon-float-ball.png);
//     display: inline-block;
//     width: 0.8rem;
//     height: 0.8rem;
//     background-size: contain;
//     background-repeat: no-repeat;
//     background-position: left;
//     &.sleep {
//           display: inline-block;
//           width: 0.8rem;
//           height: 0.8rem;
//           background-size: contain;
//           background-repeat: no-repeat;
//           background-position: left;
//         background-image: url(../assets/img/icon-float-ball-sleep.png);
//         .icon-float-ball {
//             background-image: url(../assets/img/icon-float-ball-sleep.png);
//         }
//         &.reverse {
//           display: inline-block;
//           width: 0.8rem;
//           height: 0.8rem;
//           background-size: contain;
//           background-repeat: no-repeat;
//           background-position: left;
//           background-position: right;
//           background-image: url(../assets/img/icon-float-ball-sleep-r.png);
//             .icon-float-ball {
//                 background-position: right;
//                 background-image: url(../assets/img/icon-float-ball-sleep-r.png);
//             }
//         }
//     }
//     &.transtion {
//         transition: 0.5s ease;
//     }
//     &.fade {
//         opacity: 0.8 !important;
//     }
// }

// .icon-float-ball {
//     background-image: url(../assets/img/icon-float-ball.png);
//     display: inline-block;
//     width: 0.8rem;
//     height: 0.8rem;
//     background-size: contain;
//     background-repeat: no-repeat;
//     background-position: left;

// }
</style>
